import { List, StoreListingCard } from '@petsmart-ui/sparky';

import { getStoreDisplayTime, storeIsOpen } from '@libs/common-next';
import { SearchStore } from '@libs/common-types';

export type StoreListItemProps = {
    item: SearchStore;
    onClick: (storeNumber: number) => void;
    showStock?: boolean;
    isSelected?: boolean;
    isMyStore?: boolean;
};

export function StoreListItem({ item, onClick, showStock, isSelected, isMyStore }: Readonly<StoreListItemProps>) {
    const { Store, DistanceToStoreFromOrigin, UnitOfDistance } = item;

    const timezonedDate = new Date().toLocaleString('en', {
        timeZone: Store.TimeZone?.TimeZoneId,
    });

    // date we are comparing to uses the timezone of the store we are using
    const currentDate = new Date(timezonedDate);

    return (
        <List.Item onClick={() => onClick(item.Store.StoreNumber)}>
            <StoreListingCard
                data-testid={`store-test-${Store.StoreNumber}`}
                address={{
                    addressName: Store.Name,
                    street: Store.StreetLine1,
                    city: Store.City,
                    state: Store.StateProvinceAbbreviation,
                    postalCode: Store.ZipPostalCode,
                }}
                stockStatus={Store.CurrentProductStockstatus}
                showStock={showStock}
                selected={isSelected}
                hasRadio
                hasItems={Store.HasCurrentProductInStock}
                rating={undefined}
                openText={getStoreDisplayTime(Store, currentDate)}
                distance={
                    DistanceToStoreFromOrigin > 0
                        ? `${DistanceToStoreFromOrigin.toFixed(1)} ${UnitOfDistance.replace(
                              'kilometers',
                              'kilometres'
                          )}`
                        : undefined
                }
                closed={!storeIsOpen(Store, currentDate)}
                myStore={isMyStore}
            />
        </List.Item>
    );
}
